import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'modal.details.card_details',
        defaultMessage: 'Card details',
    },
    number: {
        id: 'modal.details.number',
        defaultMessage: 'Card number',
    },
    date: {
        id: 'modal.details.expiration_date',
        defaultMessage: 'Expiration date',
    },
    code: {
        id: 'modal.details.code',
        defaultMessage: 'Security code',
    },
    name: {
        id: 'modal.details.name',
        defaultMessage: 'Cardholder name',
    },
    button: {
        id: 'modal.details.button',
        defaultMessage: 'Close',
    },
})
